"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderPopover_unstable", {
    enumerable: true,
    get: ()=>renderPopover_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _popoverContext = require("../../popoverContext");
const renderPopover_unstable = (state)=>{
    const { appearance , arrowRef , contentRef , inline , mountNode , open , openOnContext , openOnHover , setOpen , size , toggleOpen , trapFocus , triggerRef , withArrow , inertTrapFocus  } = state;
    return /*#__PURE__*/ _react.createElement(_popoverContext.PopoverContext.Provider, {
        value: {
            appearance,
            arrowRef,
            contentRef,
            inline,
            mountNode,
            open,
            openOnContext,
            openOnHover,
            setOpen,
            toggleOpen,
            triggerRef,
            size,
            trapFocus,
            inertTrapFocus,
            withArrow
        }
    }, state.popoverTrigger, state.open && state.popoverSurface);
}; //# sourceMappingURL=renderPopover.js.map

//# sourceMappingURL=renderPopover.js.map